import React from 'react';
import { productFaqs } from 'consts';

import ProductBlock from '../ProductBlock';
import { FaqSectionWrapper } from './FaqSectionWrapper';

import style from './faq.module.scss';

export const FAQ = ({ product }) => {
  return (
    <ProductBlock title="FAQ" noCamel>
      <div className={style.faqsWrapper}>
        {productFaqs.map(({ question, answer }, index) => (
          <FaqSectionWrapper
            header={question}
            answer={answer}
            key={index}
            product={product}
          />
        ))}
      </div>
    </ProductBlock>
  );
};
